// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat Sidebar New Conversation and Forward Message */

.roq-chat-create-conversation-sidebar {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}

.roq-chat-create-conversation-sidebar__header {
  padding: 0 var(--spacing-medium);
}

.roq-chat-create-conversation-sidebar__content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
}

.roq-chat-create-conversation-sidebar__content__list {
  flex-grow: 1;
  height: 100%;
  overflow-y: auto;
}

/* Like a <ul> for new chat members list */
.roq-chat-member-list__list {
  height: 100%;
  padding: 0 var(--spacing-medium);
}

@media (min-width: 768px) {
  .roq-chat-member-list__list {
    height: 50vh;
  }
}

.roq-chat-create-conversation-sidebar__header__top,
.roq-chat-forward-message-sidebar__header__top {
  display: flex;
  font-weight: var(--font-semibold);
  gap: var(--spacing-small);
  padding: var(--spacing-small);
}

.roq-chat-sidebar-search {
  padding: var(--spacing-small);
  padding-top: 0;
  position: relative;
}

.roq-chat-sidebar-search__icon {
  inset: 0 auto;
  left: var(--spacing-small);
  margin: auto 0 auto var(--spacing-small);
  position: absolute;
}

.roq-chat-sidebar-search__input {
  border: var(--border-dark);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-tiny);
  padding-left: var(--spacing-large);
  width: 100%;
}

.roq-chat-member-list__list__meber {
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: var(--spacing-small);
}

.roq-chat-member-list__list__meber:hover {
  background-color: var(--color-hover-light);
}

.roq-chat-member__avatar {
  margin-right: var(--spacing-small);
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/roqChat/_sidebar-conversation-new.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["/* Chat Sidebar New Conversation and Forward Message */\n\n.roq-chat-create-conversation-sidebar {\n  display: flex;\n  flex-direction: column;\n  max-height: 100%;\n}\n\n.roq-chat-create-conversation-sidebar__header {\n  padding: 0 var(--spacing-medium);\n}\n\n.roq-chat-create-conversation-sidebar__content {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  height: 100%;\n  overflow: hidden;\n}\n\n.roq-chat-create-conversation-sidebar__content__list {\n  flex-grow: 1;\n  height: 100%;\n  overflow-y: auto;\n}\n\n/* Like a <ul> for new chat members list */\n.roq-chat-member-list__list {\n  height: 100%;\n  padding: 0 var(--spacing-medium);\n}\n\n@media (min-width: 768px) {\n  .roq-chat-member-list__list {\n    height: 50vh;\n  }\n}\n\n.roq-chat-create-conversation-sidebar__header__top,\n.roq-chat-forward-message-sidebar__header__top {\n  display: flex;\n  font-weight: var(--font-semibold);\n  gap: var(--spacing-small);\n  padding: var(--spacing-small);\n}\n\n.roq-chat-sidebar-search {\n  padding: var(--spacing-small);\n  padding-top: 0;\n  position: relative;\n}\n\n.roq-chat-sidebar-search__icon {\n  inset: 0 auto;\n  left: var(--spacing-small);\n  margin: auto 0 auto var(--spacing-small);\n  position: absolute;\n}\n\n.roq-chat-sidebar-search__input {\n  border: var(--border-dark);\n  border-radius: var(--border-radius-small);\n  padding: var(--spacing-tiny);\n  padding-left: var(--spacing-large);\n  width: 100%;\n}\n\n.roq-chat-member-list__list__meber {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  padding: var(--spacing-small);\n}\n\n.roq-chat-member-list__list__meber:hover {\n  background-color: var(--color-hover-light);\n}\n\n.roq-chat-member__avatar {\n  margin-right: var(--spacing-small);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
